import React from "react";
import "./WTP.css";
import { Link } from "react-router-dom";
export default function WaterTreatmentLayout() {
  const stats = [
    "95% contaminants removed",
    "Serving 2M+ people daily",
    "Energy-efficient processes",
    "Zero-waste recycling initiatives",
  ];

  const processSteps = [
   { title: "Collection & Screening", desc: "Raw water collected and large debris removed." },
    { title: "Coagulation & Sedimentation", desc: "Particles clump together and settle." },
    { title: "Filtration", desc: "Sand, carbon, and membranes filter impurities." },
    { title: "Disinfection", desc: "UV light and chlorine neutralize pathogens." },
    { title: "Storage & Distribution", desc: "Clean water stored and supplied to homes." },
  ]
  return (
    <div className="layout">
      {/* Hero */}
      <section className="hero-wtp" style={{background:"url('/images/WTP.jpeg') center/cover no-repeat",backgroundSize:"100%"}}>
      <div className="wtp-overlay"></div>
  <div className="hero-wtp-content">
    <h1>Water Treatment Plants</h1>
    <p className="wtp-lead">
      Delivering safe, sustainable, and high‑quality water through advanced treatment systems
      designed for industrial, commercial, and municipal needs.
    </p>
   <Link to="/contact">  <button className="wtp-cta-btn">Request a Consultation</button></Link>
  </div>
</section>

      {/* Description Section */}
      <section className="description">
        <div className="description-text">
          <h2>The Journey of Water Purification</h2>
          <p>
            Water treatment plants are essential facilities that ensure safe, clean water for
          communities and industries. They remove impurities, neutralize harmful microorganisms,
          and recycle resources to protect both human health and the environment. By combining
          advanced technologies with sustainable practices, these plants play a vital role in
          addressing global water challenges.
          </p>
          <p>
            Water treatment is a process that makes water more acceptable for a specific end-use. The end use maybe drinking, industrial water supply,
            irrigation, river flow maintenance, water recreation or many other uses, including being 
            safely returned to the environment. Water treatment removes contaminants and undesirable components,
            or reduces their concentration so that the water becomes fit for its desired end-use
          </p>
        </div>
        <img src="/images/WTP2.png" alt="Water Treatment Plant" className="description-img" />
      </section>

      {/* Stats Section */}
      <section className="stats">
        {stats.map((stat, i) => (
          <div key={i} className="stat-card">{stat}</div>
        ))}
      </section>

      {/* Process Section */}
      <section className="process">
        <h2>Water Treatment Process</h2>
        <div className="process-list">
          {processSteps.map((step, i) => (
            <div key={i} className="process-step">
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Community Section */}
      <section className="community">
        <img src="/images/Community_tank.png" alt="Community Water Tanks" />
        <div className="community-text">
          <h2>Community & Sustainability</h2>
          <p>
             Our plants not only provide safe drinking water but also promote
            reuse, recycling, and environmental protection for future generations.
          </p>
        </div>
      </section>
    </div>
  );
}